export default __webpack_public_path__ + "static/media/ic-spinner.8715bd5b.svg";